<!--商品领取页面-->
<
<template>
  <section>
    <!--工具条-->
    <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>

    <!--列表-->
    <el-table :data="dataList" v-loading="listLoading" style="width: 100%" ref="table" @select="dialogCheck"
              @row-click="selectCurrentRow" class="custom-tbl">
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column prop="Id" width="编号"></el-table-column>
      <el-table-column prop="ProductName" label="商品名称" sortable>
      </el-table-column>
      <el-table-column prop="Quantity" label="领取数量" sortable>
      </el-table-column>
      <el-table-column prop="SysUserInfo.Name" label="领取人" sortable>
      </el-table-column>
      <el-table-column prop="SysUserInfo.Phone" label="手机号" sortable>
      </el-table-column>
      <el-table-column prop="SysUserInfo.AvatarUrl" label="头像" width="" sortable>
        <template slot-scope="scope">
          <el-avatar :src="scope.row.SysUserInfo.AvatarUrl"/>
        </template>
      </el-table-column>

      <el-table-column prop="Status" label="状态" width="" sortable>
        <template slot-scope="scope">
          <el-tag v-if="scope.row.Status === 0" type="#409EFF">
            已领取
          </el-tag>
          <el-tag v-else-if="scope.row.Status === 1" type="info">
            失效
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="SysUserInfo.MembershipExpiryDate" label="会员过期时间" sortable :formatter="formatDate">
      </el-table-column>
      <el-table-column prop="CreateTime" label="领取时间" sortable>
      </el-table-column>

    </el-table>
    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="10" :total="total"
                     style="float: right">
      </el-pagination>
    </el-col>
    <!--新增界面-->
    <el-dialog title="新增" :visible.sync="addFormVisible" v-model="addFormVisible" :close-on-click-modal="false">
      <el-form :model="addForm" label-width="80px" ref="addForm">
        <el-form-item label="昵称" prop="uRealName">
          <el-input v-model="addForm.uRealName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="登录名" prop="uLoginName">
          <el-input v-model="addForm.uLoginName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="uLoginPWD">
          <el-input v-model="addForm.uLoginPWD" show-password auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="性别">
          <el-radio-group v-model="addForm.sex">
            <el-radio class="radio" :label="1">男</el-radio>
            <el-radio class="radio" :label="0">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="年龄">
          <el-input-number v-model="addForm.age" :min="0" :max="200"></el-input-number>
        </el-form-item>
        <el-form-item label="生日">
          <el-date-picker type="date" placeholder="选择日期" v-model="addForm.birth"></el-date-picker>
        </el-form-item>
        <el-form-item label="地址">
          <el-input type="textarea" v-model="addForm.addr"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
      </div>
    </el-dialog>
    <!--编辑界面-->
    <el-dialog title="编辑" :visible.sync="editFormVisible" v-model="editFormVisible" :close-on-click-modal="false">
      <el-form :model="editForm" label-width="80px" ref="editForm">
        <el-form-item label="商品名称" prop="ProductName">
          <el-input v-model="editForm.ProductName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="数量">
          <el-input-number v-model="editForm.Quantity" :min="0" :max="200"></el-input-number>
        </el-form-item>

        <el-form-item label="状态">
          <el-radio-group v-model="editForm.Status">
            <el-radio class="radio" :label="0">领取</el-radio>
            <el-radio class="radio" :label="1">失效</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import util from "../../../util/date";
import {
  getDepartmentTree,
  getProductRedemption, getRoleListPage,
  updateProductRedemption,
  deleteProductRedemption, removeUser
} from "../../api/api";
import {
  getButtonList
} from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";

export default {
  components: {
    Toolbar
  },
  data() {
    return {
      buttonList: [],
      currentRow: null,
      filters: {
        name: "",
      },
      states: [{1: "领取"}, {1: "失效"}],
      dataList: [],
      total: 0,
      page: 1,
      listLoading: false,
      editLoading: false,
      addLoading: false,
      addFormVisible: false, //新增界面是否显示
      editFormVisible: false, //编辑界面是否显示
      //新增界面数据
      addForm: {
        ProductName: "",
        Quantity: "",
        Status: "",
      },
      //编辑界面数据
      editForm: {
        id: 0,
        uID: 0,
        RIDs: 0,
        uLoginName: "",
        uRealName: "",
        name: "",
        sex: -1,
        age: 0,
        birth: "",
        addr: "",
        Dids: [],
        DepartmentId: 0,
      },
    };
  },
  methods: {
    formatDate(row, column, cellValue, index) {
      if (cellValue) {
        const date = new Date(cellValue);
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
      } else {
        return '';
      }
    },
    dialogCheck(selection, row) {
      this.currentRow = null;
      this.$refs.table.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.selectCurrentRow(row);
      }
    },
    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val;
        this.$refs.table.clearSelection();
        this.$refs.table.toggleRowSelection(val, true);
      }
    },
    callFunction(item) {
      this.filters = {
        name: item.search,
      };
      console.log("callFunction",item)
      this[item.Func].apply(this, item);
    },
    handleCurrentChange(val) {

      this.page = val;
      this.handleQuery();
    },
    //点击按钮查询
    handleQuery() {
      this.getDataPageList();
    },
    handleAdd() {

    },
    handleUpdate() {
      let row = this.currentRow;
      this.options = [];
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });

        return;
      }
      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);

      getRoleListPage().then((res) => {
        this.roles = res.data.response.data;
      });

      let para = {
        pid: 0
      };
      getDepartmentTree(para).then((res) => {
        ++this.isResouceShow;
        this.options.push(res.data.response);
      });
    },
    handleDel() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要删除的一行数据！",
          type: "error",
        });

        return;
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
          .then(() => {
            this.listLoading = true;
            //NProgress.start();
            let para = {
              id: row.Id
            };
            console.log("删除",para)
            deleteProductRedemption(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.listLoading = false;
                return;
              }
              this.listLoading = false;
              //NProgress.done();
              if (res.data.success) {
                this.$message({
                  message: "删除成功",
                  type: "success",
                });
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }

              this.handleQuery();
            });
          })
          .catch(() => {
          });
    },


    //获取商品领取列表
    getDataPageList() {
      let para = {
        page: this.page,
        key: this.filters.name,
      };
      console.log("getDataPageList",para)
      this.listLoading = true;
      getProductRedemption(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.dataList = res.data.response.data;
        this.listLoading = false;
        //NProgress.done();
      });
    },
    //编辑
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.editLoading = true;
          //NProgress.start();
          let para = Object.assign({}, this.editForm);
          updateProductRedemption(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.editLoading = false;
              return;
            }
            if (res.data.success) {
              this.editLoading = false;
              this.$message({
                message: res.data.msg,
                type: "success",
              });
              this.$refs["editForm"].resetFields();
              this.options = [];
              this.editFormVisible = false;
              this.handleQuery();
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
        }
      });
    },

  },
  mounted() {
    this.getDataPageList();

    let routers = window.localStorage.router ?
        JSON.parse(window.localStorage.router) : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}
</style>
